function setCustomEventPolyfill() {
  function CustomEvent(event, params = { bubbles: false, cancelable: false, detail: void 0 }) {
    const evt = document.createEvent("CustomEvent");
    evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
    return evt;
  }
  CustomEvent.prototype = Event.prototype;
  window.CustomEvent = CustomEvent;
}
const createCustomEvent = (eventName) => {
  if (typeof window.CustomEvent !== "function") {
    setCustomEventPolyfill();
  }
  return new window.CustomEvent(eventName);
};
export {
  createCustomEvent
};
//# sourceMappingURL=create-custom-event.js.map
